module.exports = __webpack_public_path__ + "static/img/banner-20q3ika-bb-lotus200.04b9319.jpg";